<template>
	<AppLayout :title="trans('tools.academic-certificates.submissions.title')">
		<Pagination :resource="academicCertificates"/>
		<Empty v-if="academicCertificates.data.length === 0"/>
		<CardGrid v-else>
			<Card v-for="academicCertificate in academicCertificates.data" :key="`academic-certificates-${academicCertificate.id}`" :title="academicCertificate.user.full_name" :subtitle="dayjs(academicCertificate.created_at).format(trans('general.dayjs.date'))">
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('tools.academic-certificates.submissions.edit', academicCertificate.id)">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
		<Pagination :resource="academicCertificates"/>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type AcademicCertificate} from '@/Types/Tools/AcademicCertificate'

const props = defineProps<{
	academicCertificates:PaginatedModel<AcademicCertificate>,
}>()

const academicCertificates:Ref<PaginatedModel<AcademicCertificate>> = ref(props.academicCertificates)
</script>